module.exports = __webpack_public_path__ + "static/media/purty_wood.350ab537.png";